module.exports = __webpack_public_path__ + "img/A11_3.5c3bb64d.png";